import { DecoratorNode } from 'lexical'
import { Suspense } from 'react'

function extractYouTubeID(url) {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/,
    /youtube\.com\/embed\/([^&\s]+)/,
  ]

  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match) return match[1]
  }

  return url
}

export class YouTubeNode extends DecoratorNode {
  __videoID

  static getType() {
    return 'youtube'
  }

  static clone(node) {
    return new YouTubeNode(node.__videoID, node.__key)
  }

  constructor(videoID, key) {
    super(key)
    this.__videoID = extractYouTubeID(videoID)
  }

  createDOM(config) {
    const div = document.createElement('div')
    div.style.display = 'block'
    div.style.position = 'relative'
    div.style.paddingBottom = '56.25%'
    div.style.height = '0'
    div.style.overflow = 'hidden'
    div.style.margin = '1rem 0'
    return div
  }

  updateDOM() {
    return false
  }

  decorate() {
    return (
      <div
        style={{
          position: 'relative',
          paddingBottom: '56.25%',
          height: 0,
          overflow: 'hidden',
          margin: '1rem 0',
        }}
      >
        <iframe
          src={`https://www.youtube.com/embed/${this.__videoID}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </div>
    )
  }

  exportJSON() {
    return {
      type: 'youtube',
      version: 1,
      videoID: this.__videoID,
    }
  }

  static importJSON(serializedNode) {
    const { videoID } = serializedNode
    return $createYouTubeNode(videoID)
  }

  getVideoID() {
    return this.__videoID
  }
}

export function $createYouTubeNode(videoID) {
  return new YouTubeNode(videoID)
}

export function $isYouTubeNode(node) {
  return node instanceof YouTubeNode
}
